import type { RouteRecordRaw } from 'vue-router'
// import HomeView from '@/pages/HomeView.vue'
// import Dynamic from '@/pages/demos/dynamic/index.vue'
// import VueUse from '@/pages/demos/vueuse/index.vue'

// const NotFind = () => import('@/pages/404/index.vue')
// const demosWrapper = () => import('@/pages/demos/index.vue')
// const Axios = () => import('@/pages/demos/axios/index.vue')
// const Element = () => import('@/pages/demos/element/index.vue')

const routes: RouteRecordRaw[] = [
  // { path: '/:pathMatch(.*)*', name: 'NotFound', component: NotFind },
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home/home.vue')
  },
  {
    path: '/home', // 添加重定向路径
    redirect: '/' // 重定向到根路径
  },
  {
    path: '/laboratory/smart-hardware',
    name: 'SmartHardware',
    component: () => import('@/views/laboratory/smart-hardware.vue')
  },
  {
    path: '/talent/industry-college',
    name: 'TalentIndustryCollege',
    component: () => import('@/views/talent/industry-college.vue')
  },
  {
    path: '/talent/ai-plus',
    name: 'TalentAiPlus',
    component: () => import('@/views/talent/ai-plus.vue')
  },
  {
    path: '/teacher-training',
    name: 'TeacherTraining',
    component: () => import('@/views/teacher-training/index.vue')
  },
  {
    path: '/official-document',
    name: 'OfficialDocument',
    component: () => import('@/views/official-document/index.vue')
  },
  {
    path: '/official-document/:id',
    name: 'OfficialDocumentDetail',
    component: () => import('@/views/official-document/detail.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/about/aboutpage.vue')
  },
  {
    path: '/laboratory/ai',
    name: 'AiLaboratory',
    component: () => import('@/views/laboratory/ai.vue')
  },
  {
    path: '/laboratory/intelligent-car-race',
    name: 'IntelligentCarRace',
    component: () => import('@/views/laboratory/intelligent-car-race.vue')
  }
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (About.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import('../../pages/AboutView.vue')
  // },
  // {
  //   path: '/demos',
  //   name: 'demos',
  //   component: demosWrapper,
  //   redirect: '/demos/element',
  //   children: [
  //     { path: 'element', component: Element, name: 'element' },
  //     { path: 'axios', component: Axios, name: 'axios' },
  //     { path: 'vueuse', component: VueUse, name: 'vueuse' },
  //     {
  //       path: 'dynamic/:id',
  //       component: Dynamic,
  //       meta: {
  //         requireLogin: false,
  //         isAdmin: true
  //       },
  //       name: 'dynamic'
  //     }
  //   ]
  // }
]

export default routes
